import RequesterV1 from "@/components/api/v1/requester.js";

export default {

  fetchProducers(organization_id, harvest_process_id, current_page, rows_per_page) {
    return RequesterV1.get(
      `organization/production/query_by_producers/show_process/${organization_id}/fetch_producers/${harvest_process_id}/${current_page}/${rows_per_page}`
    );
  },

  fetchTotalProducers(organization_id, harvest_process_id) {
    return RequesterV1.get(
      `organization/production/query_by_producers/show_process/${organization_id}/fetch_total_producers/${harvest_process_id}`
    );
  },

  fetchHarvestProcess(organization_id, harvest_process_id) {
    return RequesterV1.get(
      `organization/production/query_by_producers/show_process/${organization_id}/fetch_harvest_process/${harvest_process_id}`
    );
  },

  fetchSummary(organization_id, harvest_process_id) {
    return RequesterV1.get(
      `organization/production/query_by_producers/show_process/${organization_id}/fetch_summary/${harvest_process_id}`
    );
  },

  fetchProducersSummary(organization_id, harvest_process_id) {
    return RequesterV1.get(
      `organization/production/query_by_producers/show_process/${organization_id}/fetch_producers_summary/${harvest_process_id}`
    );
  },

  fetchCropSizeSummary(organization_id, harvest_process_id) {
    return RequesterV1.get(
      `organization/production/query_by_producers/show_process/${organization_id}/fetch_crop_size_summary/${harvest_process_id}`
    );
  },

  fetchCropSizesByProducer(organization_id, harvest_process_id, crop_size_id) {
    return RequesterV1.get(
      `organization/production/query_by_producers/show_process/${organization_id}/fetch_crop_size_by_producer/${harvest_process_id}/${crop_size_id}`
    );
  }
}
